module.exports = "/static/assets/a299dfce333bc76558e0bd663bddf0c9.gif";